/**
 * Legacy currency/date helpers — now delegate to the centralized US config.
 * Kept for backward compatibility with existing imports. New code should
 * import from "@/config/locale" directly.
 */
import { formatCurrency, formatDate, formatDateTime } from "../config/locale";

/** @deprecated Use formatCurrency from @/config/locale. Signature kept for legacy call sites. */
export function formatEuroAmount(amount) {
  return formatCurrency(amount);
}

/** USD amount helper — the "modern" name. */
export function formatUsdAmount(amount) {
  return formatCurrency(amount);
}

/** @deprecated Use formatDate from @/config/locale. Now returns MM/DD/YYYY. */
export function formatDateShort(iso) {
  return formatDate(iso);
}

export { formatCurrency, formatDate, formatDateTime };
